import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const dict = {
  it: {
    nav: {
      home: "Home",
      products: "Prodotti",
      pet: "Linea Pet",
      human: "Linea Human",
      science: "Scienza e qualità",
      about: "Chi siamo",
      journal: "Journal",
      faq: "FAQ",
      pro: "Professionisti",
      contact: "Contatti",
      shop_cta: "Scopri i prodotti",
    },
    home: {
      overline: "Benessere Italiano",
      hero_title: "Benessere scientifico per persone e animali.",
      hero_sub:
        "BioNutrix sviluppa soluzioni dedicate al benessere quotidiano, unendo ingredienti selezionati, competenza scientifica e qualità italiana.",
      hero_cta_pet: "Scopri la linea Pet",
      hero_cta_about: "Conosci BioNutrix",
      lines_title: "Due linee, un solo standard di qualità",
      lines_sub: "Formulazioni pensate per accompagnare la vita di ogni giorno.",
      pet_desc: "Formule dedicate al benessere quotidiano di cani e gatti.",
      human_desc: "Una nuova linea dedicata al benessere delle persone.",
      pet_cta: "Scopri i prodotti Pet",
      human_cta: "Ricevi gli aggiornamenti",
      coming_soon: "Prossimamente",
      products_title: "Prodotti in evidenza",
      products_sub: "Formule complete, disponibili su Amazon.",
      why_title: "Perché BioNutrix",
      why_sub: "Piccole scelte che fanno la differenza.",
      why_formulas: "Formulazioni studiate",
      why_formulas_txt: "Composizioni pensate per accompagnare la routine quotidiana.",
      why_ingredients: "Ingredienti selezionati",
      why_ingredients_txt: "Materie prime scelte con attenzione, tracciate e documentate.",
      why_italy: "Qualità Made in Italy",
      why_italy_txt: "Prodotti realizzati in Italia, secondo standard qualitativi elevati.",
      why_care: "Attenzione per persone e animali",
      why_care_txt: "Formule pensate per prendersi cura di chi ami, ogni giorno.",
      nature_title: "Natura e ricerca, insieme.",
      nature_txt:
        "In BioNutrix cerchiamo ogni giorno un equilibrio tra conoscenza scientifica, ingredienti selezionati e semplicità di utilizzo. Non promettiamo miracoli: costruiamo formulazioni prudenti, chiare e trasparenti.",
      quality_title: "Qualità e produzione",
      quality_txt:
        "Produzione italiana, controllo delle materie prime, processi produttivi tracciati e attenzione agli standard qualitativi.",
      journal_title: "Dal Journal",
      journal_sub: "Contenuti informativi su nutrizione, benessere e cura quotidiana.",
      pro_title: "Porta BioNutrix nella tua attività",
      pro_txt:
        "Scopri le opportunità commerciali dedicate ai professionisti e richiedi il catalogo BioNutrix.",
      pro_cta: "Richiedi informazioni commerciali",
      newsletter_title: "Resta aggiornato sul mondo BioNutrix",
      newsletter_sub: "Iscriviti per ricevere aggiornamenti, articoli e novità.",
    },
    common: {
      buy_amazon: "Acquista su Amazon",
      discover: "Scopri il prodotto",
      read_more: "Leggi di più",
      subscribe: "Iscriviti",
      submit: "Invia",
      sending: "Invio in corso…",
      name: "Nome",
      email: "Email",
      phone: "Telefono",
      message: "Messaggio",
      required: "Campo obbligatorio",
      privacy_consent: "Ho letto la Privacy Policy e acconsento al trattamento dei dati.",
      marketing_consent: "Acconsento a ricevere comunicazioni commerciali.",
      thanks: "Grazie!",
      error: "Si è verificato un errore. Riprova.",
      loading: "Caricamento…",
      view_all: "Vedi tutti",
      back: "Indietro",
    },
    footer: {
      tagline: "Benessere scientifico per persone e animali.",
      company: "Azienda",
      products: "Prodotti",
      resources: "Risorse",
      legal: "Legale",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      terms: "Termini e condizioni",
      cookie_prefs: "Preferenze cookie",
      accessibility: "Accessibilità",
      admin: "Area riservata",
      copyright: "Tutti i diritti riservati.",
      social: "Seguici",
    },
    cookie: {
      title: "Rispettiamo la tua privacy",
      text:
        "Utilizziamo cookie tecnici necessari al funzionamento del sito. Con il tuo consenso possiamo usare cookie analitici per migliorare l'esperienza. Non utilizziamo cookie di profilazione senza il tuo consenso.",
      accept: "Accetta",
      reject: "Rifiuta",
      customize: "Personalizza",
      save: "Salva preferenze",
      necessary: "Necessari",
      analytics: "Analytics",
      marketing: "Marketing",
    },
    product: {
      buy_amazon: "Acquista su Amazon",
      buy_amazon_sub: "Sarai reindirizzato su Amazon in una nuova scheda.",
      areas: "Aree di supporto",
      formulation: "Caratteristiche della formulazione",
      ingredients: "Composizione e ingredienti",
      analytical: "Componenti analitici",
      how_to_use: "Modalità d'uso",
      warnings: "Avvertenze",
      quality: "Qualità",
      quality_txt:
        "Formulato e prodotto in Italia. Confronta sempre i dati con l'etichetta ufficiale riportata sulla confezione.",
      faq: "Domande frequenti",
      related: "Prodotti correlati",
      disclaimer:
        "I contenuti hanno finalità informative e non sostituiscono il parere del medico veterinario. In caso di patologie, gravidanza, allattamento o terapie in corso, consulta il tuo veterinario.",
      quantity: "Quantità",
      species: "Destinato a",
      badges: {
        made_in_italy: "Made in Italy",
        dogs_cats: "Cani e gatti",
      },
    },
    filters: {
      all_lines: "Tutte le linee",
      line_pet: "Linea Pet",
      line_human: "Linea Human",
      species: "Destinazione",
      dog: "Cane",
      cat: "Gatto",
      person: "Persona",
      search: "Cerca prodotto…",
      no_results: "Nessun prodotto trovato con questi filtri.",
    },
    human: {
      overline: "In sviluppo",
      title: "BioNutrix Human",
      sub:
        "Stiamo lavorando a una nuova linea dedicata al benessere delle persone, sviluppata secondo i principi di qualità, trasparenza e ricerca che guidano BioNutrix.",
      manifesto_title: "Il nostro manifesto",
      manifesto_txt:
        "Vogliamo portare nel mondo della nutraceutica umana la stessa attenzione, prudenza e trasparenza che ci guida oggi nella linea Pet. Formule chiare, ingredienti selezionati, comunicazione responsabile.",
      notify_title: "Ricevi gli aggiornamenti sul lancio",
      notify_sub: "Ti scriveremo esclusivamente per aggiornarti sul lancio della linea Human.",
      areas_label: "Aree di interesse",
      areas: [
        "Energia e vitalità",
        "Equilibrio intestinale",
        "Difese naturali",
        "Sonno e rilassamento",
        "Mobilità",
        "Altro",
      ],
    },
    admin: {
      login_title: "Area riservata",
      login_sub: "Accesso amministratori BioNutrix",
      email: "Email",
      password: "Password",
      login_btn: "Accedi",
      dashboard: "Dashboard",
      logout: "Esci",
      tab_products: "Prodotti",
      tab_articles: "Articoli",
      tab_faqs: "FAQ",
      tab_leads: "Lead",
      tab_reviews: "Recensioni",
      tab_settings: "Impostazioni",
    },
    b2b: {
      title: "Professionisti e rivenditori",
      sub:
        "Porta BioNutrix nella tua attività. Compila il modulo: il nostro team commerciale ti contatterà con le informazioni richieste.",
      first_name: "Nome",
      last_name: "Cognome",
      company: "Azienda",
      category: "Categoria professionale",
      categories: {
        veterinario: "Veterinario",
        farmacia: "Farmacia",
        parafarmacia: "Parafarmacia",
        pet_shop: "Pet shop",
        distributore: "Distributore",
        altro: "Altro",
      },
      vat: "Partita IVA",
      city: "Città",
      province: "Provincia",
      phone: "Telefono",
      interest: "Interesse (linea Pet, Human, entrambe…)",
      message: "Messaggio",
    },
    contact: {
      title: "Contatti",
      sub: "Scrivici per informazioni, assistenza, collaborazioni commerciali o stampa.",
      topic: "Argomento",
      topics: {
        info: "Informazioni sui prodotti",
        assistance: "Assistenza",
        commercial: "Collaborazione commerciale",
        press: "Stampa e comunicazione",
        other: "Altro",
      },
      company_data: "Dati societari",
    },
  },
  en: {
    nav: {
      home: "Home",
      products: "Products",
      pet: "Pet Line",
      human: "Human Line",
      science: "Science & Quality",
      about: "About",
      journal: "Journal",
      faq: "FAQ",
      pro: "Professionals",
      contact: "Contact",
      shop_cta: "Explore products",
    },
    home: {
      overline: "Italian Wellness",
      hero_title: "Scientific wellness for people and animals.",
      hero_sub:
        "BioNutrix develops daily-wellness solutions, blending selected ingredients, scientific expertise and Italian quality.",
      hero_cta_pet: "Discover the Pet line",
      hero_cta_about: "About BioNutrix",
      lines_title: "Two lines, one quality standard",
      lines_sub: "Formulations designed for everyday life.",
      pet_desc: "Formulas dedicated to the daily wellness of dogs and cats.",
      human_desc: "A new line dedicated to human wellbeing.",
      pet_cta: "See Pet products",
      human_cta: "Get updates",
      coming_soon: "Coming soon",
      products_title: "Featured products",
      products_sub: "Complete formulas, available on Amazon.",
      why_title: "Why BioNutrix",
      why_sub: "Small choices that make the difference.",
      why_formulas: "Studied formulations",
      why_formulas_txt: "Compositions designed to accompany daily routines.",
      why_ingredients: "Selected ingredients",
      why_ingredients_txt: "Raw materials carefully chosen, traced and documented.",
      why_italy: "Made in Italy quality",
      why_italy_txt: "Manufactured in Italy to high quality standards.",
      why_care: "Care for people and animals",
      why_care_txt: "Formulas designed to look after the ones you love, every day.",
      nature_title: "Nature and research, together.",
      nature_txt:
        "At BioNutrix we look for a daily balance between scientific knowledge, selected ingredients and ease of use. We do not promise miracles: we build cautious, transparent formulations.",
      quality_title: "Quality and production",
      quality_txt:
        "Italian production, traced raw materials, controlled processes and attention to quality standards.",
      journal_title: "From the Journal",
      journal_sub: "Informational content on nutrition, wellness and daily care.",
      pro_title: "Bring BioNutrix to your business",
      pro_txt: "Discover commercial opportunities for professionals and request our catalogue.",
      pro_cta: "Request commercial info",
      newsletter_title: "Stay updated on the BioNutrix world",
      newsletter_sub: "Subscribe to receive updates, articles and news.",
    },
    common: {
      buy_amazon: "Buy on Amazon",
      discover: "Discover the product",
      read_more: "Read more",
      subscribe: "Subscribe",
      submit: "Send",
      sending: "Sending…",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      required: "Required field",
      privacy_consent: "I have read the Privacy Policy and consent to the processing of data.",
      marketing_consent: "I consent to receive marketing communications.",
      thanks: "Thank you!",
      error: "Something went wrong. Please try again.",
      loading: "Loading…",
      view_all: "View all",
      back: "Back",
    },
    footer: {
      tagline: "Scientific wellness for people and animals.",
      company: "Company",
      products: "Products",
      resources: "Resources",
      legal: "Legal",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      terms: "Terms & Conditions",
      cookie_prefs: "Cookie preferences",
      accessibility: "Accessibility",
      admin: "Admin area",
      copyright: "All rights reserved.",
      social: "Follow us",
    },
    cookie: {
      title: "We respect your privacy",
      text:
        "We use necessary technical cookies. With your consent, we may use analytics cookies to improve your experience. No profiling cookies are used without consent.",
      accept: "Accept",
      reject: "Reject",
      customize: "Customize",
      save: "Save preferences",
      necessary: "Necessary",
      analytics: "Analytics",
      marketing: "Marketing",
    },
    product: {
      buy_amazon: "Buy on Amazon",
      buy_amazon_sub: "You'll be redirected to Amazon in a new tab.",
      areas: "Areas of support",
      formulation: "Formulation highlights",
      ingredients: "Composition and ingredients",
      analytical: "Analytical components",
      how_to_use: "How to use",
      warnings: "Warnings",
      quality: "Quality",
      quality_txt:
        "Formulated and manufactured in Italy. Always cross-check data with the official label on the packaging.",
      faq: "Frequently asked questions",
      related: "Related products",
      disclaimer:
        "The content is for informational purposes and does not replace veterinary advice. In case of pathologies, pregnancy, lactation or ongoing therapies, consult your veterinarian.",
      quantity: "Quantity",
      species: "Intended for",
      badges: {
        made_in_italy: "Made in Italy",
        dogs_cats: "Dogs and cats",
      },
    },
    filters: {
      all_lines: "All lines",
      line_pet: "Pet Line",
      line_human: "Human Line",
      species: "Intended for",
      dog: "Dog",
      cat: "Cat",
      person: "Person",
      search: "Search product…",
      no_results: "No products match these filters.",
    },
    human: {
      overline: "In development",
      title: "BioNutrix Human",
      sub:
        "We are developing a new line dedicated to human wellbeing, guided by the same principles of quality, transparency and research that shape BioNutrix.",
      manifesto_title: "Our manifesto",
      manifesto_txt:
        "We aim to bring to human nutraceuticals the same care, caution and transparency that today guide our Pet line. Clear formulas, selected ingredients, responsible communication.",
      notify_title: "Get notified at launch",
      notify_sub: "We will only write to you to share updates about the Human line.",
      areas_label: "Areas of interest",
      areas: [
        "Energy and vitality",
        "Intestinal balance",
        "Natural defenses",
        "Sleep and relaxation",
        "Mobility",
        "Other",
      ],
    },
    admin: {
      login_title: "Admin area",
      login_sub: "BioNutrix administrator access",
      email: "Email",
      password: "Password",
      login_btn: "Sign in",
      dashboard: "Dashboard",
      logout: "Sign out",
      tab_products: "Products",
      tab_articles: "Articles",
      tab_faqs: "FAQ",
      tab_leads: "Leads",
      tab_reviews: "Reviews",
      tab_settings: "Settings",
    },
    b2b: {
      title: "Professionals & resellers",
      sub:
        "Bring BioNutrix to your business. Fill out the form: our commercial team will get back to you.",
      first_name: "First name",
      last_name: "Last name",
      company: "Company",
      category: "Professional category",
      categories: {
        veterinario: "Veterinarian",
        farmacia: "Pharmacy",
        parafarmacia: "Parapharmacy",
        pet_shop: "Pet shop",
        distributore: "Distributor",
        altro: "Other",
      },
      vat: "VAT number",
      city: "City",
      province: "Province",
      phone: "Phone",
      interest: "Interest (Pet, Human, both…)",
      message: "Message",
    },
    contact: {
      title: "Contact",
      sub: "Write to us for information, support, commercial partnerships or press.",
      topic: "Topic",
      topics: {
        info: "Product information",
        assistance: "Support",
        commercial: "Commercial partnership",
        press: "Press & communication",
        other: "Other",
      },
      company_data: "Company data",
    },
  },
};

const I18nCtx = createContext(null);

const IT_LANG_RE = /^it\b/i;

function detectInitialLang() {
  // 1) explicit user choice wins
  const stored = localStorage.getItem("bnx_lang");
  if (stored === "it" || stored === "en") return stored;
  // 2) URL param override (?lang=en)
  try {
    const params = new URLSearchParams(window.location.search);
    const p = params.get("lang");
    if (p === "it" || p === "en") return p;
  } catch (_e) {}
  // 3) browser language
  const nav = (navigator.language || navigator.userLanguage || "en").toLowerCase();
  return IT_LANG_RE.test(nav) ? "it" : "en";
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => detectInitialLang());

  // Persist + reflect on <html>
  useEffect(() => {
    localStorage.setItem("bnx_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  // Async geo refinement — only if the user hasn't explicitly chosen yet
  useEffect(() => {
    if (localStorage.getItem("bnx_lang_user") === "1") return;
    const controller = new AbortController();
    fetch("https://ipapi.co/json/", { signal: controller.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!d || !d.country_code) return;
        const desired = d.country_code === "IT" ? "it" : "en";
        if (localStorage.getItem("bnx_lang_user") === "1") return;
        setLangState(desired);
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);

  const setLang = useCallback((l) => {
    localStorage.setItem("bnx_lang_user", "1");
    setLangState(l);
  }, []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = dict[lang];
      for (const p of parts) {
        if (cur == null) return path;
        cur = cur[p];
      }
      return cur == null ? path : cur;
    },
    [lang],
  );

  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}

// Utility: pick a translated field from a document with `translations: { en: {...} }`
export function tr(doc, lang, field) {
  if (!doc) return "";
  if (lang === "it") return doc[field] ?? "";
  const en = doc.translations?.en;
  if (en && en[field] != null) return en[field];
  return doc[field] ?? "";
}
